import { Colors, Language, Lightning, Log, Router } from '@lightningjs/sdk'
import Button from '../components/buttons/Button'
import { isString } from '../lib/AppHelpers'

export default class ErrorBox extends Lightning.Component {
  static _template() {
    return {
      w: 1920,
      h: 1080,
      rect: true,
      color: Colors('black')
        .alpha(0.8)
        .get(),
      Dialog: {
        w: 1200,
        h: 500,
        x: 477,
        y: 277,
        rect: true,
        color: Colors('PageBG').get(),
        shader: { radius: 22, type: Lightning.shaders.RoundedRectangle },

        Title: {
          y: 77,
          w: 1200,
          h: 68,
          color: Colors('white').get(),
          text: {
            text: this.bindProp('title'),
            textAlign: 'center',
            fontSize: 50,
            fontFace: 'OpenSansBold',
            lineHeight: 68,
          },
        },
        Description: {
          y: 155,
          x: 1200 / 2,
          w: 905,
          h: 180,
          mountX: 0.5,
          color: Colors('white').get(),
          text: {
            text: this.bindProp('descr'),
            textAlign: 'center',
            fontSize: 25,
            fontFace: 'OpenSansLight',
            lineHeight: 35,
          },
        },

        NoButton: {
          w: 200,
          h: 60,
          x: 385,
          y: 364,
          type: Button,
          buttonText: Language.translate('No'),
        },
        YesButton: {
          w: 200,
          h: 60,
          x: 615,
          y: 364,
          type: Button,
          buttonText: Language.translate('Yes'),
        },
        OkayButton: {
          w: 200,
          h: 60,
          x: 500,
          y: 364,
          alpha: 0,
          type: Button,
          buttonText: Language.translate('Okay'),
        },
      },
    }
  }

  notify({ type, item, Notification = true, videoResult, route }) {
    Log.error('ErrorBox: ', { type, item, videoResult, route })

    this._fromRoute = route

    let title, descr

    switch (type) {
      case 'notFoundError':
        title = Language.translate('ErrNotFoundTitle')
        descr = Language.translate('ErrNotFoundDescr')
        break
      case 'playbackError':
        title = Language.translate('ErrPlaybackTitle')
        descr = Language.translate('ErrPlaybackDescr')
        break
      case 'playbackStopped':
        title = Language.translate('ErrPlaybackTitle')
        descr = Language.translate('ErrPlaybackStopped')
        break
      default:
        title = Language.translate('ErrGeneralTitle')
        descr = Language.translate('ErrGeneralDescr')
        break
    }
    this.patch({ title, descr })
    if (Notification) {
      this.tag('YesButton').alpha = 0
      this.tag('NoButton').alpha = 0
      this.tag('OkayButton').alpha = 1
      this._setState('Okay')
    } else {
      this._setState('YesButton')
    }
  }

  _init() {}
  _inactive() {
    this.stage.gc()
  }
  _focus() {
    this.alpha = 1
  }
  _unfocus() {
    this.alpha = 0
  }

  static _states() {
    return [
      class Idle extends this {
        _getFocused() {
          return this
        }
      },

      class YesButton extends this {
        _handleLeft() {
          this._setState('NoButton')
        }

        _handleEnter() {
          const history = Router.getHistory()
          if (isString(this._fromRoute)) {
            Router.navigate(this._fromRoute)
          } else if (history && history.length) {
            Router.back()
          } else {
            Router.navigate('radio')
          }
        }

        _getFocused() {
          return this.tag('YesButton')
        }
      },

      class NoButton extends this {
        _handleRight() {
          this._setState('YesButton')
        }

        _handleEnter() {
          Router.navigate('radio')
        }

        _getFocused() {
          return this.tag('NoButton')
        }
      },
      class Okay extends this {
        _handleRight() {
          // do nothing
        }

        _handleEnter() {
          // TODO close
          Router.focusPage()
        }

        _getFocused() {
          return this.tag('OkayButton')
        }
      },
    ]
  }
}
